
export default class EqualDivider {

    private readonly result: Array<Object>;

    /**
     * Equal Divider
     *
     * @param number to be divided
     * @param parts how many divisions?
     */
    constructor(number: number, parts: number) {

        const perPart = number / parts;

        let extraAllocation = 0;

        // Division has reminder
        if (perPart % 1 !== 0) {
            const totalAllocated = Math.floor(perPart) * parts;
            extraAllocation = number - totalAllocated;
        }

        this.result = [];

        for (let i=0;i<parts;i++) {

            const addition = extraAllocation > 0 ? 1 : 0;

            extraAllocation--;

            this.result.push(Math.floor(perPart) + addition);
        }
    }

    public getResults() {
        return this.result;
    }
}

